import styled from "styled-components";
import { UserIcon } from "../../atoms/icons/sidebar/UserIcon";

type Props = {
  clientName: string;
  username: string;
  handleLogout: () => void;
};

export const SidebarFooter: React.FC<Props> = ({
  clientName,
  username,
  handleLogout,
}) => {
  return (
    <StyledFooterContainer onClick={handleLogout}>
      <StyledCompanyName>{clientName}</StyledCompanyName>

      <StyledUserNameContainer>
        <UserIcon />

        <StyledUserName>{username}</StyledUserName>
      </StyledUserNameContainer>
    </StyledFooterContainer>
  );
};

const StyledFooterContainer = styled.div`
  padding: 10px 14px;
  width: 248px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  cursor: pointer;
`;

const StyledCompanyName = styled.div`
  color: #333333;
  font-size: 11px;
  font-weight: 400;
  line-height: 100%;
`;

const StyledUserNameContainer = styled.div`
  width: 191px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const StyledUserName = styled.div`
  color: #333333;
  font-size: 14px;
  font-weight: 700;
  line-height: 100%;
`;
